// tslint:disable
/**
 * Web API Account Service
 * Service for perform account operations, such as creating accounts or recovering accounts.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: kundtjanst@travsport.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, parseDateTime } from '../runtime';

import {
    AuthenticatedUser,
    AuthenticatedUserFromJSON,
    AuthenticatedUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface BankIdCollectedAccountCreation
 */
export interface BankIdCollectedAccountCreation  {
    /**
     * Transaction status.
     * @type {string}
     * @memberof BankIdCollectedAccountCreation
     */
    status: BankIdCollectedAccountCreationStatusEnum;
    /**
     * Bank id hint code.
     * @type {string}
     * @memberof BankIdCollectedAccountCreation
     */
    hintCode?: string;
    /**
     * The qr code pattern used to generate the animated qr code.
     * @type {string}
     * @memberof BankIdCollectedAccountCreation
     */
    qrCodePattern?: string;
    /**
     * Only present in the response from collect when an account has been successfully created and the user is now logged in.
     * @type {string}
     * @memberof BankIdCollectedAccountCreation
     */
    authenticationMethod?: BankIdCollectedAccountCreationAuthenticationMethodEnum;
    /**
     * 
     * @type {AuthenticatedUser}
     * @memberof BankIdCollectedAccountCreation
     */
    authenticatedUser?: AuthenticatedUser;
}

export function BankIdCollectedAccountCreationFromJSON(json: any): BankIdCollectedAccountCreation {
    return {
        'status': json['status'],
        'hintCode': !exists(json, 'hintCode') ? undefined : json['hintCode'],
        'qrCodePattern': !exists(json, 'qrCodePattern') ? undefined : json['qrCodePattern'],
        'authenticationMethod': !exists(json, 'authenticationMethod') ? undefined : json['authenticationMethod'],
        'authenticatedUser': !exists(json, 'authenticatedUser') ? undefined : AuthenticatedUserFromJSON(json['authenticatedUser']),
    };
}

export function BankIdCollectedAccountCreationToJSON(value?: BankIdCollectedAccountCreation): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'status': value.status,
        'hintCode': value.hintCode,
        'qrCodePattern': value.qrCodePattern,
        'authenticationMethod': value.authenticationMethod,
        'authenticatedUser': AuthenticatedUserToJSON(value.authenticatedUser),
    };
}

/**
* @export
* @enum {string}
*/
export enum BankIdCollectedAccountCreationStatusEnum {
    PENDING = 'pending',
    FAILED = 'failed',
    COMPLETE = 'complete'
}
/**
* @export
* @enum {string}
*/
export enum BankIdCollectedAccountCreationAuthenticationMethodEnum {
    ANONYMOUS = 'ANONYMOUS',
    PASSWORD = 'PASSWORD',
    BANKID = 'BANKID',
    FREJA_EID = 'FREJA_EID',
    SUBSCRIPTION = 'SUBSCRIPTION'
}


